export default __webpack_public_path__ + "static/media/amendmentLaw.168917de.svg";